// Generated by Claude (Claude Code) while extracting IssueCard from
// IssueBoardPage. Conversation: https://claude.ai/code/session_018qcqzEaBiPmP1GQv1wWoop
//
// One owner for the status key -> icon / colour mapping, shared by the issue
// card, the issue detail dialog and the board's stat cards.
import { AlertCircle, CheckCircle2, Clock, Tag } from "lucide-react";

export function statusIcon(key: string | undefined, sizeClass = "w-4 h-4") {
  switch (key) {
    case "new":
      return <AlertCircle className={`${sizeClass} text-destructive`} />;
    case "in_progress":
      return <Clock className={`${sizeClass} text-blue-500`} />;
    case "resolved":
      return <CheckCircle2 className={`${sizeClass} text-emerald-500`} />;
    default:
      return <Tag className={`${sizeClass} text-slate-400`} />;
  }
}

export function statusColor(key: string | undefined) {
  switch (key) {
    case "new":
      return "text-destructive";
    case "in_progress":
      return "text-blue-500";
    case "resolved":
      return "text-emerald-500";
    default:
      return "text-slate-500";
  }
}

// Production's active keys are new / confirmed / working / resolved. open,
// in_progress and in_review are retired there but still seeded locally.
/** DNA status-pill colors for the public board. Ink-on-amber (never white-on-amber). */
export function statusPillStyle(key: string | undefined): { background: string; color: string } {
  switch (key) {
    case "new":
      return { background: "var(--dna-warning-bg)", color: "var(--dna-warning)" };
    case "in_review":
      return { background: "var(--dna-amber-100)", color: "var(--dna-amber-700)" };
    case "confirmed":
    case "open":
      return { background: "var(--dna-info-bg)", color: "var(--dna-info)" };
    case "working":
    case "in_progress":
      return { background: "var(--dna-indigo-100)", color: "var(--dna-indigo-700)" };
    case "resolved":
      return { background: "var(--dna-success-bg)", color: "var(--dna-success)" };
    default:
      return { background: "var(--dna-slate-100)", color: "var(--dna-slate-700)" };
  }
}

export function statusLegendText(key: string | undefined): string {
  switch (key) {
    case "new":
      return "A carrier reported this. DNA has not reviewed it yet.";
    case "in_review":
      return "DNA is reviewing this report.";
    case "confirmed":
    case "open":
      return "DNA has confirmed this is a real MOTUS problem.";
    case "working":
    case "in_progress":
      return "A fix is in progress.";
    case "resolved":
      return "This issue has been fixed.";
    default:
      return "Staff-assigned status for this issue.";
  }
}
